import { createSlice } from "@reduxjs/toolkit";

const catalogSlice = createSlice({
  name: "catalog",
  initialState: {
    cards: null,
    bouquets: null,
    filter: null,
    filterBouquets: null,
    setting: null,
    news: null,
    categories: null,
    sections: null,
    displayMode: "flat",
  },
  reducers: {
    setNewCards(state, action) {
      state.cards = action.payload;
    },
    setNewBouquets(state, action) {
      state.bouquets = action.payload;
    },
    setFilter(state, action) {
      state.filter = action.payload;
    },
    setFilterBouquets(state, action) {
      state.filterBouquets = action.payload;
    },
    setNewSetting(state, action) {
      state.setting = action.payload;
    },
    setNewNews(state, action) {
      state.news = action.payload;
    },
    setNewCategories(state, action) {
      state.categories = action.payload;
    },
    setNewSections(state, action) {
      state.sections = action.payload;
    },
    setDisplayMode(state, action) {
      state.displayMode = action.payload || "flat";
    },
  },
});

export const {
  setNewCards,
  setNewBouquets,
  setFilter,
  setFilterBouquets,
  setNewSetting,
  setNewNews,
  setNewCategories,
  setNewSections,
  setDisplayMode,
} = catalogSlice.actions;

export default catalogSlice.reducer;
